/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1TrustedStories, updateTKT1TrustedStory, createTKT1TrustedStory } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal,
  Image,
  Toast,
  ToastContainer
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaPlus } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';

class TKT1TrustedStory extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'created_at',
    sortOrder: -1,
    search: '',
    type: '',
    status: ''
  }

  initShowColumns = {
    MID: true,
    type: true,
    artist_name: true,
    artist_story: false,
    etsy_shop_name: true,
    etsy_shop_story: false,
    location: true,
    website: false,
    facebook_username: false,
    instagram_username: false,
    x_username: false,
    youtube_channel: false,
    status: true,
    ref_real_story_mid: false,
    ref_etsy_info_pack_mid: true,
    note: false,
    is_active: true,
    created_at: false
  }

  initColumnWidths = {
    stt: 60,
    MID: 120,
    type: 100,
    artist_name: 200,
    artist_story: 250,
    etsy_shop_name: 200,
    etsy_shop_story: 250,
    location: 150,
    website: 200,
    facebook_username: 150,
    instagram_username: 150,
    x_username: 150,
    youtube_channel: 200,
    status: 120,
    ref_real_story_mid: 150,
    ref_etsy_info_pack_mid: 180,
    note: 200,
    is_active: 120,
    created_at: 150,
    actions: 100
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      columnWidths: this.initColumnWidths,
      loading: false,
      showConfigModal: false,
      showEditModal: false,
      showViewModal: false,
      showCreateModal: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedStory: null,
      isEditMode: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null,
      realStories: [],
      editFormData: {
        type: 'REAL',
        ref_real_story_mid: '',
        artist_name: '',
        artist_story: '',
        artist_avatars: [],
        team_story: [],
        etsy_shop_name: '',
        etsy_shop_story: '',
        shop_logos: [],
        location: '',
        website: '',
        facebook_username: '',
        instagram_username: '',
        x_username: '',
        youtube_channel: '',
        status: 'draft',
        ref_etsy_info_pack_mid: '',
        note: '',
        metadata: {},
        is_active: true
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Trusted Story';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Clean up conflicting parameters
      delete queryObject.is_active; // Remove old parameter
      
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      const viewConfig = JSON.parse(localStorage.getItem('TKT1TrustedStory_ViewConfig'));
      const columnWidths = JSON.parse(localStorage.getItem('TKT1TrustedStory_ColumnWidths'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        columnWidths: {
          ...this.initColumnWidths,
          ...(columnWidths || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1TrustedStories(apiQuery);
      })
    } else {
      var query = JSON.parse(localStorage.getItem('tkt1_trusted_story_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1TrustedStory_ViewConfig'));
      var columnWidths = JSON.parse(localStorage.getItem('TKT1TrustedStory_ColumnWidths'));
      
      if (query) {
        // Clean up conflicting parameters from localStorage
        delete query.is_active; // Remove old parameter
        
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1TrustedStories(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1TrustedStories(apiQuery);
        })
      }
    }
    
    // Add mouse event listeners for column resizing
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
    
    // Load real stories for dropdown
    this.loadRealStories();
  }

  componentWillUnmount() {
    // Remove mouse event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  loadRealStories = async () => {
    try {
      // Load only REAL stories for dropdown
      const realStoriesQuery = {
        type: 'REAL',
        itemsPerPage: 1000,
        currentPage: 1,
        sortBy: 'artist_name',
        sortOrder: 1
      };
      await this.props.getTKT1TrustedStories(realStoriesQuery);
      
      // Get real stories from props and store in local state
      if (this.props.trustedStories) {
        this.setState({
          realStories: this.props.trustedStories.filter(story => story.type === 'REAL')
        });
      }
    } catch (error) {
      console.error('Error loading real stories:', error);
    }
  }

  showToast = (message, type = 'success') => {
    this.setState({
      showToast: true,
      toastMessage: message,
      toastType: type
    });
    
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    const newQuery = { 
      ...this.state.query, 
      search: '',
      currentPage: 1 // Reset to first page on clear
    };
    this.updateQueryAndFetch(newQuery);
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      currentPage: 1 // Reset to first page on search
    };
    
    this.updateQueryAndFetch(trimmedQuery);
  }

  // Helper method to consistently update query, localStorage, URL, and fetch data
  updateQueryAndFetch = (newQuery) => {
    console.log('[Debug] updateQueryAndFetch - newQuery:', newQuery);
    const apiQuery = this.prepareApiQuery(newQuery);
    console.log('[Debug] updateQueryAndFetch - apiQuery:', apiQuery);
    
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_trusted_story_query', JSON.stringify(newQuery));
    this.updateUrl(newQuery);
    this.props.getTKT1TrustedStories(apiQuery);
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  prepareApiQuery = (query) => {
    const { showColumns, search, type, status, show_sidebar, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    if (type && type.trim()) {
      apiQuery.type = type;
    }
    
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    return apiQuery;
  }

  updateUrl = (query) => {
    const { history } = this.props;
    
    // Clean URL query - only include necessary parameters and exclude conflicting ones
    const cleanUrlQuery = {
      currentPage: query.currentPage,
      itemsPerPage: query.itemsPerPage,
      sortBy: query.sortBy,
      sortOrder: query.sortOrder,
      search: query.search || '',
      type: query.type || '',
      status: query.status || ''
    };
    
    // Remove empty values to keep URL clean
    Object.keys(cleanUrlQuery).forEach(key => {
      if (cleanUrlQuery[key] === '' || cleanUrlQuery[key] === null || cleanUrlQuery[key] === undefined) {
        delete cleanUrlQuery[key];
      }
    });
    
    const queryStr = queryString.stringify(cleanUrlQuery);

    history.push({
      pathname: '/admin/tkt1-asset/trusted-story',
      search: queryStr,
    });
  }

  handleCreateClick = () => {
    this.setState({
      showCreateModal: true,
      selectedStory: null,
      isEditMode: false,
      editFormData: {
        type: 'REAL',
        ref_real_story_mid: '',
        artist_name: '',
        artist_story: '',
        artist_avatars: [],
        team_story: [],
        etsy_shop_name: '',
        etsy_shop_story: '',
        shop_logos: [],
        location: '',
        website: '',
        facebook_username: '',
        instagram_username: '',
        x_username: '',
        youtube_channel: '',
        status: 'draft',
        ref_etsy_info_pack_mid: '',
        note: '',
        metadata: {},
        is_active: true
      }
    });
  }

  handleCreateFictionFromReal = (realStory) => {
    this.setState({
      showCreateModal: true,
      selectedStory: null,
      isEditMode: false,
      editFormData: {
        type: 'MODIFY',
        ref_real_story_mid: realStory.MID,
        artist_name: realStory.artist_name || '',
        artist_story: realStory.artist_story || '',
        artist_avatars: realStory.artist_avatars || [],
        team_story: realStory.team_story || [],
        etsy_shop_name: realStory.etsy_shop_name || '',
        etsy_shop_story: realStory.etsy_shop_story || '',
        shop_logos: realStory.shop_logos || [],
        location: realStory.location || '',
        website: realStory.website || '',
        facebook_username: realStory.facebook_username || '',
        instagram_username: realStory.instagram_username || '',
        x_username: realStory.x_username || '',
        youtube_channel: realStory.youtube_channel || '',
        status: 'draft',
        ref_etsy_info_pack_mid: realStory.ref_etsy_info_pack_mid || '',
        note: realStory.note || '',
        metadata: realStory.metadata || {},
        is_active: true
      }
    });
  }

  handleFormChange = (field, value) => {
    this.setState(prevState => {
      const newFormData = {
        ...prevState.editFormData,
        [field]: value
      };
      
      // If type changes to MODIFY and a real story is selected, populate fields
      if (field === 'ref_real_story_mid' && value && prevState.editFormData.type === 'MODIFY') {
        const selectedRealStory = this.state.realStories.find(story => story.MID === value);
        if (selectedRealStory) {
          return {
            editFormData: {
              ...newFormData,
              artist_name: selectedRealStory.artist_name || '',
              artist_story: selectedRealStory.artist_story || '',
              etsy_shop_name: selectedRealStory.etsy_shop_name || '',
              etsy_shop_story: selectedRealStory.etsy_shop_story || '',
              location: selectedRealStory.location || '',
              website: selectedRealStory.website || '',
              facebook_username: selectedRealStory.facebook_username || '',
              instagram_username: selectedRealStory.instagram_username || '',
              x_username: selectedRealStory.x_username || '',
              youtube_channel: selectedRealStory.youtube_channel || ''
            }
          };
        }
      }
      
      // If type changes to REAL or FICTION, clear ref_real_story_mid (only MODIFY needs real story)
      if (field === 'type' && (value === 'REAL' || value === 'FICTION')) {
        newFormData.ref_real_story_mid = '';
      }
      
      return { editFormData: newFormData };
    });
  }

  handleSubmitEdit = async () => {
    try {
      this.setState({ loading: true });
      
      const { selectedStory, editFormData } = this.state;
      
      console.log('Submitting form:', { isEditMode: this.state.isEditMode, editFormData });
      
      if (this.state.isEditMode) {
        // Update existing story
        console.log('Updating trusted story:', selectedStory._id, editFormData);
        await this.props.updateTKT1TrustedStory(selectedStory._id, editFormData);
        this.showToast('Cập nhật câu chuyện tin cậy thành công!', 'success');
      } else {
        // Create new story
        console.log('Creating trusted story:', editFormData);
        await this.props.createTKT1TrustedStory(editFormData);
        this.showToast('Thêm câu chuyện tin cậy mới thành công!', 'success');
      }
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      await this.props.getTKT1TrustedStories(apiQuery);
      
      // Close modals
      this.setState({
        showEditModal: false,
        showCreateModal: false,
        selectedStory: null,
        isEditMode: false,
        loading: false
      });
      
      console.log('Trusted story saved successfully');
      
    } catch (error) {
      console.error('Error saving trusted story:', error);
      this.showToast('Có lỗi xảy ra khi lưu dữ liệu!', 'error');
      this.setState({ loading: false });
    }
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      selectedStory: null,
      isEditMode: false
    });
  }

  handleConfigChange = (column, value) => {
    this.setState(prevState => ({
      showColumns: {
        ...prevState.showColumns,
        [column]: value
      }
    }));
  }

  handleSaveConfig = () => {
    localStorage.setItem('TKT1TrustedStory_ViewConfig', JSON.stringify(this.state.showColumns));
    this.setState({ showConfigModal: false });
  }

  // Column resizing handlers
  resetColumnWidths = () => {
    this.setState({ columnWidths: this.initColumnWidths });
    localStorage.removeItem('TKT1TrustedStory_ColumnWidths');
  }

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  handleMouseDown = (e, columnKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
      isResizing: true,
      resizingColumn: columnKey,
      resizeStartX: e.clientX,
      resizeStartWidth: this.state.columnWidths[columnKey]
    });
    
    document.body.classList.add('table-resizing');
  }

  handleMouseMove = (e) => {
    if (!this.state.isResizing || !this.state.resizingColumn) return;
    
    e.preventDefault();
    const deltaX = e.clientX - this.state.resizeStartX;
    const newWidth = Math.max(50, this.state.resizeStartWidth + deltaX);
    const resizingColumn = this.state.resizingColumn;
    
    this.setState(prevState => ({
      columnWidths: {
        ...prevState.columnWidths,
        [resizingColumn]: newWidth
      }
    }));
  }

  handleMouseUp = () => {
    if (this.state.isResizing) {
      this.setState({
        isResizing: false,
        resizingColumn: null,
        resizeStartX: null,
        resizeStartWidth: null
      });
      
      document.body.classList.remove('table-resizing');
      
      // Save column widths to localStorage
      localStorage.setItem('TKT1TrustedStory_ColumnWidths', JSON.stringify(this.state.columnWidths));
    }
  }

  mapStatus = (status) => {
    switch(status) {
      case 'deactive': return { text: 'Deactive', bg: 'secondary' };
      case 'draft': return { text: 'Draft', bg: 'warning' };
      case 'publish': return { text: 'Publish', bg: 'success' };
      default: return { text: status || 'Draft', bg: 'warning' };
    }
  }

  handleCloseConfigModal = () => {
    this.setState({ showConfigModal: false });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Etsy Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo tên nghệ sĩ, shop Etsy, MID..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Loại</InputGroup.Text>
            <Form.Select
              value={this.state.query.type}
              onChange={(e) => {
                const newQuery = { 
                  ...this.state.query, 
                  type: e.target.value,
                  currentPage: 1 // Reset to first page on filter change
                };
                this.updateQueryAndFetch(newQuery);
              }}
            >
              <option value="">Tất cả</option>
              <option value="REAL">Thật</option>
              <option value="MODIFY">Chỉnh sửa</option>
              <option value="FICTION">Hư cấu</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={(e) => {
                const newQuery = { 
                  ...this.state.query, 
                  status: e.target.value,
                  currentPage: 1 // Reset to first page on filter change
                };
                this.updateQueryAndFetch(newQuery);
              }}
            >
              <option value="">Tất cả</option>
              <option value="deactive">Deactive</option>
              <option value="draft">Draft</option>
              <option value="publish">Publish</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={(e) => {
                const newQuery = { 
                  ...this.state.query, 
                  sortBy: e.target.value 
                };
                this.updateQueryAndFetch(newQuery);
              }}
            >
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="artist_name">Tên nghệ sĩ</option>
              <option value="etsy_shop_name">Tên shop Etsy</option>
              <option value="MID">MID</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={(e) => {
                const newQuery = { 
                  ...this.state.query, 
                  sortOrder: parseInt(e.target.value) 
                };
                this.updateQueryAndFetch(newQuery);
              }}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2" className="d-flex align-items-center">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderTrustedStoryTable = () => {
    const { trustedStories } = this.props;
    const { showColumns, columnWidths } = this.state;
    
    console.log('[Debug] renderTrustedStoryTable - trustedStories:', trustedStories);
    console.log('[Debug] renderTrustedStoryTable - type:', typeof trustedStories);
    console.log('[Debug] renderTrustedStoryTable - isArray:', Array.isArray(trustedStories));
    
    const safeStories = Array.isArray(trustedStories) ? trustedStories.filter(story => story != null && typeof story === 'object') : [];
    
    console.log('[Debug] renderTrustedStoryTable - safeStories:', safeStories);
    
    if (!safeStories || safeStories.length === 0) {
      return (
        <Table striped bordered hover style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
                STT
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
                />
              </th>
              {showColumns.MID && <th style={{ width: `${columnWidths.MID}px`, position: 'relative' }}>
                MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'MID')}
                />
              </th>}
              {showColumns.type && <th style={{ width: `${columnWidths.type}px`, position: 'relative' }}>
                Loại
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'type')}
                />
              </th>}
              {showColumns.artist_name && <th style={{ width: `${columnWidths.artist_name}px`, position: 'relative' }}>
                Tên nghệ sĩ
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'artist_name')}
                />
              </th>}
              {showColumns.artist_story && <th style={{ width: `${columnWidths.artist_story}px`, position: 'relative' }}>
                Câu chuyện nghệ sĩ
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'artist_story')}
                />
              </th>}
              {showColumns.etsy_shop_name && <th style={{ width: `${columnWidths.etsy_shop_name}px`, position: 'relative' }}>
                Tên shop Etsy
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'etsy_shop_name')}
                />
              </th>}
              {showColumns.etsy_shop_story && <th style={{ width: `${columnWidths.etsy_shop_story}px`, position: 'relative' }}>
                Câu chuyện shop
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'etsy_shop_story')}
                />
              </th>}
              {showColumns.location && <th style={{ width: `${columnWidths.location}px`, position: 'relative' }}>
                Địa điểm
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'location')}
                />
              </th>}
              {showColumns.website && <th style={{ width: `${columnWidths.website}px`, position: 'relative' }}>
                Website
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'website')}
                />
              </th>}
              {showColumns.facebook_username && <th style={{ width: `${columnWidths.facebook_username}px`, position: 'relative' }}>
                Facebook
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'facebook_username')}
                />
              </th>}
              {showColumns.instagram_username && <th style={{ width: `${columnWidths.instagram_username}px`, position: 'relative' }}>
                Instagram
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'instagram_username')}
                />
              </th>}
              {showColumns.x_username && <th style={{ width: `${columnWidths.x_username}px`, position: 'relative' }}>
                X (Twitter)
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'x_username')}
                />
              </th>}
              {showColumns.youtube_channel && <th style={{ width: `${columnWidths.youtube_channel}px`, position: 'relative' }}>
                YouTube
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'youtube_channel')}
                />
              </th>}
              {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
                Trạng thái
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'status')}
                />
              </th>}
              {showColumns.ref_real_story_mid && <th style={{ width: `${columnWidths.ref_real_story_mid}px`, position: 'relative' }}>
                Ref Real Story MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'ref_real_story_mid')}
                />
              </th>}
              {showColumns.ref_etsy_info_pack_mid && <th style={{ width: `${columnWidths.ref_etsy_info_pack_mid}px`, position: 'relative' }}>
                Ref Etsy Pack MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'ref_etsy_info_pack_mid')}
                />
              </th>}
              {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
                Ghi chú
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'note')}
                />
              </th>}
              {showColumns.is_active && <th style={{ width: `${columnWidths.is_active}px`, position: 'relative' }}>
                Hoạt động
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'is_active')}
                />
              </th>}
              {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
                Ngày tạo
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
                />
              </th>}
              <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
        <Table striped bordered hover style={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
              STT
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
              />
            </th>
            {showColumns.MID && <th style={{ width: `${columnWidths.MID}px`, position: 'relative' }}>
              MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'MID')}
              />
            </th>}
            {showColumns.type && <th style={{ width: `${columnWidths.type}px`, position: 'relative' }}>
              Loại
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'type')}
              />
            </th>}
            {showColumns.artist_name && <th style={{ width: `${columnWidths.artist_name}px`, position: 'relative' }}>
              Tên nghệ sĩ
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'artist_name')}
              />
            </th>}
            {showColumns.artist_story && <th style={{ width: `${columnWidths.artist_story}px`, position: 'relative' }}>
              Câu chuyện nghệ sĩ
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'artist_story')}
              />
            </th>}
            {showColumns.etsy_shop_name && <th style={{ width: `${columnWidths.etsy_shop_name}px`, position: 'relative' }}>
              Tên shop Etsy
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'etsy_shop_name')}
              />
            </th>}
            {showColumns.etsy_shop_story && <th style={{ width: `${columnWidths.etsy_shop_story}px`, position: 'relative' }}>
              Câu chuyện shop
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'etsy_shop_story')}
              />
            </th>}
            {showColumns.location && <th style={{ width: `${columnWidths.location}px`, position: 'relative' }}>
              Địa điểm
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'location')}
              />
            </th>}
            {showColumns.website && <th style={{ width: `${columnWidths.website}px`, position: 'relative' }}>
              Website
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'website')}
              />
            </th>}
            {showColumns.facebook_username && <th style={{ width: `${columnWidths.facebook_username}px`, position: 'relative' }}>
              Facebook
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'facebook_username')}
              />
            </th>}
            {showColumns.instagram_username && <th style={{ width: `${columnWidths.instagram_username}px`, position: 'relative' }}>
              Instagram
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'instagram_username')}
              />
            </th>}
            {showColumns.x_username && <th style={{ width: `${columnWidths.x_username}px`, position: 'relative' }}>
              X (Twitter)
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'x_username')}
              />
            </th>}
            {showColumns.youtube_channel && <th style={{ width: `${columnWidths.youtube_channel}px`, position: 'relative' }}>
              YouTube
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'youtube_channel')}
              />
            </th>}
            {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
              Trạng thái
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'status')}
              />
            </th>}
            {showColumns.ref_real_story_mid && <th style={{ width: `${columnWidths.ref_real_story_mid}px`, position: 'relative' }}>
              Ref Real Story MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'ref_real_story_mid')}
              />
            </th>}
            {showColumns.ref_etsy_info_pack_mid && <th style={{ width: `${columnWidths.ref_etsy_info_pack_mid}px`, position: 'relative' }}>
              Ref Etsy Pack MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'ref_etsy_info_pack_mid')}
              />
            </th>}
            {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
              Ghi chú
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'note')}
              />
            </th>}
            {showColumns.is_active && <th style={{ width: `${columnWidths.is_active}px`, position: 'relative' }}>
              Hoạt động
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'is_active')}
              />
            </th>}
            {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
              Ngày tạo
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
              />
            </th>}
            <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeStories.map((story, index) => {
            if (!story || typeof story !== 'object') {
              return null;
            }
              
              return (
                <tr key={story._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.MID && (
                    <td>
                      {story.MID ? (
                        <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {story.MID}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.type && (
                    <td>
                      <Badge 
                        bg={
                          story.type === 'REAL' ? 'success' : 
                          story.type === 'MODIFY' ? 'info' : 
                          'warning'
                        } 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {story.type === 'REAL' ? 'Thật' : 
                         story.type === 'MODIFY' ? 'Chỉnh sửa' : 
                         'Hư cấu'}
                      </Badge>
                    </td>
                  )}
                  {showColumns.artist_name && (
                    <td>
                      <div className="fw-bold">{story.artist_name || '-'}</div>
                    </td>
                  )}
                  {showColumns.artist_story && (
                    <td>
                      <div className="text-muted small" style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {story.artist_story || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.etsy_shop_name && (
                    <td>{story.etsy_shop_name || '-'}</td>
                  )}
                  {showColumns.etsy_shop_story && (
                    <td>
                      <div className="text-muted small" style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {story.etsy_shop_story || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.location && (
                    <td>{story.location || '-'}</td>
                  )}
                  {showColumns.website && (
                    <td>
                      {story.website ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{story.website}</span>
                          <FaExternalLinkAlt 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => window.open(story.website, '_blank')}
                            title="Mở website"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.facebook_username && (
                    <td>
                      {story.facebook_username ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{story.facebook_username}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(story.facebook_username)}
                            title="Copy Facebook username"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.instagram_username && (
                    <td>
                      {story.instagram_username ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{story.instagram_username}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(story.instagram_username)}
                            title="Copy Instagram username"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.x_username && (
                    <td>
                      {story.x_username ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{story.x_username}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(story.x_username)}
                            title="Copy X username"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.youtube_channel && (
                    <td>
                      {story.youtube_channel ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{story.youtube_channel}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(story.youtube_channel)}
                            title="Copy YouTube channel"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      <Badge 
                        bg={this.mapStatus(story.status).bg} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.mapStatus(story.status).text}
                      </Badge>
                    </td>
                  )}
                  {showColumns.ref_real_story_mid && (
                    <td>
                      {story.ref_real_story_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                            {story.ref_real_story_mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(story.ref_real_story_mid)}
                            title="Copy Real Story MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {story.ref_etsy_info_pack_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="success" 
                            style={{ 
                              fontSize: '0.8em', 
                              padding: '4px 8px', 
                              cursor: 'pointer' 
                            }}
                            onClick={() => this.handleEtsyInfoPackClick(story.ref_etsy_info_pack_mid)}
                            title="Click để xem chi tiết Etsy Info Pack"
                          >
                            {story.ref_etsy_info_pack_mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(story.ref_etsy_info_pack_mid)}
                            title="Copy Etsy Pack MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      <div className="text-muted small" style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {story.note || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.is_active && (
                    <td>
                      <Badge 
                        bg={story.is_active ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {story.is_active ? 'Có' : 'Không'}
                      </Badge>
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>{story.created_at ? new Date(story.created_at).toLocaleDateString('vi-VN') : '-'}</td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(story)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(story)}
                      />
                      {story.type === 'REAL' && (
                        <FaPlus 
                          size={16} 
                          style={{ 
                            cursor: 'pointer', 
                            color: '#28a745',
                            marginLeft: '8px'
                          }}
                          title="Tạo Modify Story từ Real Story này"
                          onClick={() => this.handleCreateFictionFromReal(story)}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  handleViewClick = (story) => {
    this.setState({
      showViewModal: true,
      selectedStory: story,
      isEditMode: false
    });
  }

  handleEditClick = (story) => {
    this.setState({
      showEditModal: true,
      selectedStory: story,
      isEditMode: true,
      editFormData: {
        type: story.type || 'REAL',
        ref_real_story_mid: story.ref_real_story_mid || '',
        artist_name: story.artist_name || '',
        artist_story: story.artist_story || '',
        artist_avatars: story.artist_avatars || [],
        team_story: story.team_story || [],
        etsy_shop_name: story.etsy_shop_name || '',
        etsy_shop_story: story.etsy_shop_story || '',
        shop_logos: story.shop_logos || [],
        location: story.location || '',
        website: story.website || '',
        facebook_username: story.facebook_username || '',
        instagram_username: story.instagram_username || '',
        x_username: story.x_username || '',
        youtube_channel: story.youtube_channel || '',
        status: story.status || 'draft',
        ref_etsy_info_pack_mid: story.ref_etsy_info_pack_mid || '',
        note: story.note || '',
        metadata: story.metadata || {},
        is_active: story.is_active !== undefined ? story.is_active : true
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedStory: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedStory: null,
      isEditMode: false
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const newQuery = {
      ...this.state.query,
      currentPage: newPage
    };
    
    this.updateQueryAndFetch(newQuery);
  }

  render() {
    const { columnWidths } = this.state;
    
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Trusted Story
              </h2>
            </Col>
            <Col className="text-end" md="auto">
              <div className="d-flex gap-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => this.setState({ showConfigModal: true })}
                  title="Cấu hình hiển thị"
                >
                  <i className="fas fa-cog me-1"></i>
                  Cấu hình
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  onClick={this.handleCreateClick}
                  title="Thêm câu chuyện tin cậy mới"
                >
                  <FaPlus /> Thêm mới
                </Button>
              </div>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={(e) => {
                      const newQuery = {
                        ...this.state.query,
                        itemsPerPage: parseInt(e.target.value),
                        currentPage: 1
                      };
                      this.updateQueryAndFetch(newQuery);
                    }}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="sticky-table">
              {this.renderTrustedStoryTable()}
              </div>
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-plus me-2"></i>
              {this.state.editFormData.type === 'MODIFY' && this.state.editFormData.ref_real_story_mid 
                ? 'Tạo Modify Story từ Real Story' 
                : 'Thêm câu chuyện tin cậy mới'
              }
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.editFormData.type === 'MODIFY' && this.state.editFormData.ref_real_story_mid && (
              <div className="alert alert-info mb-3">
                <strong>📖 Tạo Modify Story từ Real Story:</strong>
                <br />
                {(() => {
                  const realStory = this.state.realStories.find(story => story.MID === this.state.editFormData.ref_real_story_mid);
                  return realStory ? `[${realStory.MID}] ${realStory.artist_name} - ${realStory.etsy_shop_name}` : this.state.editFormData.ref_real_story_mid;
                })()}
              </div>
            )}
            <Form>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Loại câu chuyện *</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.type}
                      onChange={(e) => this.handleFormChange('type', e.target.value)}
                    >
                      <option value="REAL">Thật</option>
                      <option value="MODIFY">Chỉnh sửa</option>
                      <option value="FICTION">Hư cấu</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                {this.state.editFormData.type === 'MODIFY' && (
                  <Col md="6">
                    <Form.Group className="mb-3">
                      <Form.Label>Câu chuyện thật làm base * (bắt buộc cho MODIFY)</Form.Label>
                      <Form.Select
                        value={this.state.editFormData.ref_real_story_mid}
                        onChange={(e) => this.handleFormChange('ref_real_story_mid', e.target.value)}
                      >
                        <option value="">Chọn câu chuyện thật</option>
                        {this.state.realStories.map(story => (
                          <option key={story.MID} value={story.MID}>
                            [{story.MID}] {story.artist_name} - {story.etsy_shop_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                )}
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên nghệ sĩ *</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.artist_name}
                      onChange={(e) => this.handleFormChange('artist_name', e.target.value)}
                      placeholder="Nhập tên nghệ sĩ"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên shop Etsy</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.etsy_shop_name}
                      onChange={(e) => this.handleFormChange('etsy_shop_name', e.target.value)}
                      placeholder="Nhập tên shop Etsy"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Địa điểm</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.location}
                      onChange={(e) => this.handleFormChange('location', e.target.value)}
                      placeholder="Nhập địa điểm"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Website</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.website}
                      onChange={(e) => this.handleFormChange('website', e.target.value)}
                      placeholder="Nhập website"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Facebook Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.facebook_username}
                      onChange={(e) => this.handleFormChange('facebook_username', e.target.value)}
                      placeholder="Nhập Facebook username"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Instagram Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.instagram_username}
                      onChange={(e) => this.handleFormChange('instagram_username', e.target.value)}
                      placeholder="Nhập Instagram username"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>X (Twitter) Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.x_username}
                      onChange={(e) => this.handleFormChange('x_username', e.target.value)}
                      placeholder="Nhập X username"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>YouTube Channel</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.youtube_channel}
                      onChange={(e) => this.handleFormChange('youtube_channel', e.target.value)}
                      placeholder="Nhập YouTube channel"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleFormChange('status', e.target.value)}
                    >
                      <option value="deactive">Deactive</option>
                      <option value="draft">Draft</option>
                      <option value="publish">Publish</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Reference Etsy Info Pack MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleFormChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập Reference Etsy Info Pack MID"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Câu chuyện nghệ sĩ</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.artist_story}
                      onChange={(e) => this.handleFormChange('artist_story', e.target.value)}
                      placeholder="Nhập câu chuyện của nghệ sĩ"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Câu chuyện shop Etsy</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.etsy_shop_story}
                      onChange={(e) => this.handleFormChange('etsy_shop_story', e.target.value)}
                      placeholder="Nhập câu chuyện của shop Etsy"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleFormChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hoạt động"
                      checked={this.state.editFormData.is_active}
                      onChange={(e) => this.handleFormChange('is_active', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSubmitEdit}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Đang lưu...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Lưu
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Config Modal */}
        <Modal show={this.state.showConfigModal} onHide={this.handleCloseConfigModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-cog me-2"></i>
              Cấu hình hiển thị cột
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <h6 className="text-muted">Chọn các cột muốn hiển thị trong bảng:</h6>
            </div>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="MID"
                  label="MID"
                  checked={this.state.showColumns.MID}
                  onChange={(e) => this.handleConfigChange('MID', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="type"
                  label="Loại"
                  checked={this.state.showColumns.type}
                  onChange={(e) => this.handleConfigChange('type', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="artist_name"
                  label="Tên nghệ sĩ"
                  checked={this.state.showColumns.artist_name}
                  onChange={(e) => this.handleConfigChange('artist_name', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="artist_story"
                  label="Câu chuyện nghệ sĩ"
                  checked={this.state.showColumns.artist_story}
                  onChange={(e) => this.handleConfigChange('artist_story', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="etsy_shop_name"
                  label="Tên shop Etsy"
                  checked={this.state.showColumns.etsy_shop_name}
                  onChange={(e) => this.handleConfigChange('etsy_shop_name', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="etsy_shop_story"
                  label="Câu chuyện shop"
                  checked={this.state.showColumns.etsy_shop_story}
                  onChange={(e) => this.handleConfigChange('etsy_shop_story', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="location"
                  label="Địa điểm"
                  checked={this.state.showColumns.location}
                  onChange={(e) => this.handleConfigChange('location', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="website"
                  label="Website"
                  checked={this.state.showColumns.website}
                  onChange={(e) => this.handleConfigChange('website', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="facebook_username"
                  label="Facebook"
                  checked={this.state.showColumns.facebook_username}
                  onChange={(e) => this.handleConfigChange('facebook_username', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="instagram_username"
                  label="Instagram"
                  checked={this.state.showColumns.instagram_username}
                  onChange={(e) => this.handleConfigChange('instagram_username', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="x_username"
                  label="X (Twitter)"
                  checked={this.state.showColumns.x_username}
                  onChange={(e) => this.handleConfigChange('x_username', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="youtube_channel"
                  label="YouTube"
                  checked={this.state.showColumns.youtube_channel}
                  onChange={(e) => this.handleConfigChange('youtube_channel', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="status"
                  label="Trạng thái"
                  checked={this.state.showColumns.status}
                  onChange={(e) => this.handleConfigChange('status', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="ref_real_story_mid"
                  label="Ref Real Story MID"
                  checked={this.state.showColumns.ref_real_story_mid}
                  onChange={(e) => this.handleConfigChange('ref_real_story_mid', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="ref_etsy_info_pack_mid"
                  label="Ref Etsy Pack MID"
                  checked={this.state.showColumns.ref_etsy_info_pack_mid}
                  onChange={(e) => this.handleConfigChange('ref_etsy_info_pack_mid', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="note"
                  label="Ghi chú"
                  checked={this.state.showColumns.note}
                  onChange={(e) => this.handleConfigChange('note', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="is_active"
                  label="Hoạt động"
                  checked={this.state.showColumns.is_active}
                  onChange={(e) => this.handleConfigChange('is_active', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="created_at"
                  label="Ngày tạo"
                  checked={this.state.showColumns.created_at}
                  onChange={(e) => this.handleConfigChange('created_at', e.target.checked)}
                />
              </Col>
            </Row>
            <hr />
            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  const allColumns = {
                    MID: true,
                    type: true,
                    artist_name: true,
                    artist_story: true,
                    etsy_shop_name: true,
                    etsy_shop_story: true,
                    location: true,
                    website: true,
                    facebook_username: true,
                    instagram_username: true,
                    x_username: true,
                    youtube_channel: true,
                    status: true,
                    ref_real_story_mid: true,
                    ref_etsy_info_pack_mid: true,
                    note: true,
                    is_active: true,
                    created_at: true
                  };
                  this.setState({ showColumns: allColumns });
                }}
              >
                <i className="fas fa-check-double me-1"></i>
                Chọn tất cả
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  const noColumns = {
                    MID: false,
                    type: false,
                    artist_name: false,
                    artist_story: false,
                    etsy_shop_name: false,
                    etsy_shop_story: false,
                    location: false,
                    website: false,
                    facebook_username: false,
                    instagram_username: false,
                    x_username: false,
                    youtube_channel: false,
                    status: false,
                    ref_real_story_mid: false,
                    ref_etsy_info_pack_mid: true,
                    note: false,
                    is_active: false,
                    created_at: false
                  };
                  this.setState({ showColumns: noColumns });
                }}
              >
                <i className="fas fa-times me-1"></i>
                Bỏ chọn tất cả
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseConfigModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveConfig}>
              <i className="fas fa-save me-1"></i>
              Lưu cấu hình
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-eye me-2"></i>
              Thông tin câu chuyện tin cậy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedStory && (
              <div>
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin nghệ sĩ</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedStory.MID || '-'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Loại:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={
                          this.state.selectedStory.type === 'REAL' ? 'success' : 
                          this.state.selectedStory.type === 'MODIFY' ? 'info' : 
                          'warning'
                        } 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedStory.type === 'REAL' ? 'Thật' : 
                         this.state.selectedStory.type === 'MODIFY' ? 'Chỉnh sửa' : 
                         'Hư cấu'}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên nghệ sĩ:</strong> 
                    <div className="mt-1 fw-bold">{this.state.selectedStory.artist_name || '-'}</div>
                  </Col>
                  {this.state.selectedStory.type === 'MODIFY' && this.state.selectedStory.ref_real_story_mid && (
                    <Col md="6">
                      <strong>Ref Real Story MID:</strong> 
                      <div className="mt-1">
                        <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          {this.state.selectedStory.ref_real_story_mid}
                        </Badge>
                      </div>
                    </Col>
                  )}
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Câu chuyện nghệ sĩ:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedStory.artist_story || '-'}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin shop Etsy</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên shop Etsy:</strong> 
                    <div className="mt-1">{this.state.selectedStory.etsy_shop_name || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>Địa điểm:</strong> 
                    <div className="mt-1">{this.state.selectedStory.location || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Câu chuyện shop:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedStory.etsy_shop_story || '-'}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Mạng xã hội & Tham chiếu</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Website:</strong> 
                    <div className="mt-1">
                      {this.state.selectedStory.website ? (
                        <a href={this.state.selectedStory.website} target="_blank" rel="noopener noreferrer">
                          <FaExternalLinkAlt size={14} /> {this.state.selectedStory.website}
                        </a>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Facebook:</strong> 
                    <div className="mt-1">{this.state.selectedStory.facebook_username || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Instagram:</strong> 
                    <div className="mt-1">{this.state.selectedStory.instagram_username || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>X (Twitter):</strong> 
                    <div className="mt-1">{this.state.selectedStory.x_username || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>YouTube:</strong> 
                    <div className="mt-1">{this.state.selectedStory.youtube_channel || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>Ref Etsy Pack MID:</strong> 
                    <div className="mt-1">{this.state.selectedStory.ref_etsy_info_pack_mid || '-'}</div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái & Ghi chú</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={this.mapStatus(this.state.selectedStory.status).bg} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.mapStatus(this.state.selectedStory.status).text}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Hoạt động:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={this.state.selectedStory.is_active ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedStory.is_active ? 'Có' : 'Không'}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedStory.note || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày tạo:</strong> 
                    <div className="mt-1">
                      {this.state.selectedStory.created_at ? 
                        new Date(this.state.selectedStory.created_at).toLocaleString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày cập nhật:</strong> 
                    <div className="mt-1">
                      {this.state.selectedStory.updated_at ? 
                        new Date(this.state.selectedStory.updated_at).toLocaleString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-edit me-2"></i>
              Chỉnh sửa câu chuyện tin cậy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Loại câu chuyện *</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.type}
                      onChange={(e) => this.handleFormChange('type', e.target.value)}
                    >
                      <option value="REAL">Thật</option>
                      <option value="MODIFY">Chỉnh sửa</option>
                      <option value="FICTION">Hư cấu</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                {this.state.editFormData.type === 'MODIFY' && (
                  <Col md="6">
                    <Form.Group className="mb-3">
                      <Form.Label>Câu chuyện thật làm base * (bắt buộc cho MODIFY)</Form.Label>
                      <Form.Select
                        value={this.state.editFormData.ref_real_story_mid}
                        onChange={(e) => this.handleFormChange('ref_real_story_mid', e.target.value)}
                      >
                        <option value="">Chọn câu chuyện thật</option>
                        {this.state.realStories.map(story => (
                          <option key={story.MID} value={story.MID}>
                            [{story.MID}] {story.artist_name} - {story.etsy_shop_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                )}
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên nghệ sĩ *</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.artist_name}
                      onChange={(e) => this.handleFormChange('artist_name', e.target.value)}
                      placeholder="Nhập tên nghệ sĩ"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên shop Etsy</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.etsy_shop_name}
                      onChange={(e) => this.handleFormChange('etsy_shop_name', e.target.value)}
                      placeholder="Nhập tên shop Etsy"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Địa điểm</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.location}
                      onChange={(e) => this.handleFormChange('location', e.target.value)}
                      placeholder="Nhập địa điểm"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Website</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.website}
                      onChange={(e) => this.handleFormChange('website', e.target.value)}
                      placeholder="Nhập website"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Facebook Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.facebook_username}
                      onChange={(e) => this.handleFormChange('facebook_username', e.target.value)}
                      placeholder="Nhập Facebook username"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Instagram Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.instagram_username}
                      onChange={(e) => this.handleFormChange('instagram_username', e.target.value)}
                      placeholder="Nhập Instagram username"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>X (Twitter) Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.x_username}
                      onChange={(e) => this.handleFormChange('x_username', e.target.value)}
                      placeholder="Nhập X username"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>YouTube Channel</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.youtube_channel}
                      onChange={(e) => this.handleFormChange('youtube_channel', e.target.value)}
                      placeholder="Nhập YouTube channel"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleFormChange('status', e.target.value)}
                    >
                      <option value="deactive">Deactive</option>
                      <option value="draft">Draft</option>
                      <option value="publish">Publish</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Reference Etsy Info Pack MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleFormChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập Reference Etsy Info Pack MID"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Câu chuyện nghệ sĩ</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.artist_story}
                      onChange={(e) => this.handleFormChange('artist_story', e.target.value)}
                      placeholder="Nhập câu chuyện của nghệ sĩ"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Câu chuyện shop Etsy</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.etsy_shop_story}
                      onChange={(e) => this.handleFormChange('etsy_shop_story', e.target.value)}
                      placeholder="Nhập câu chuyện của shop Etsy"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleFormChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hoạt động"
                      checked={this.state.editFormData.is_active}
                      onChange={(e) => this.handleFormChange('is_active', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSubmitEdit}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Đang lưu...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Lưu thay đổi
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Toast Notification */}
        <ToastContainer 
          position="top-end" 
          className="p-3"
          style={{ 
            position: 'fixed', 
            top: '20px', 
            right: '20px', 
            zIndex: 9999 
          }}
        >
          <Toast 
            show={this.state.showToast} 
            onClose={() => this.setState({ showToast: false })}
            bg={this.state.toastType === 'success' ? 'success' : 'danger'}
            autohide
            delay={3000}
          >
            <Toast.Header>
              <i className={`fas fa-${this.state.toastType === 'success' ? 'check-circle' : 'exclamation-triangle'} me-2`}></i>
              <strong className="me-auto">
                {this.state.toastType === 'success' ? 'Thành công' : 'Lỗi'}
              </strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              {this.state.toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    trustedStories: state.tkt1TrustedStoryReducer.trustedStories,
    totalCount: state.tkt1TrustedStoryReducer.totalCount
  };
};

export default connect(mapStateToProps, { 
  getTKT1TrustedStories,
  updateTKT1TrustedStory,
  createTKT1TrustedStory
})(TKT1TrustedStory);
